var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "land_addon" },
    [
      _c("standart", {
        key: "parts_reserv_addon",
        attrs: {
          title: "Акт-замовлення №",
          is_active_title: true,
          is_active_preamblua: false,
          is_active_result: false,
          is_active_problem: false,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "addon_fields_main" }, [
        _c(
          "div",
          { staticClass: "auction_land_fields" },
          [
            _vm.draw_addon_fields.length > 0
              ? _c("b-container", { attrs: { fluid: "" } }, [
                  _c(
                    "div",
                    { staticClass: "main_info" },
                    _vm._l(this.draw_addon_fields, function (field) {
                      return _c(
                        "b-row",
                        { key: field.id, staticClass: "doc_title" },
                        [
                          _c("b-col", { attrs: { sm: "3" } }, [
                            _c(
                              "label",
                              { attrs: { for: field.type + field.id } },
                              [_vm._v(_vm._s(field.name) + " ")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "6" } },
                            [
                              field.type == "input"
                                ? _c("b-form-input", {
                                    staticClass: "fs-xl",
                                    attrs: {
                                      type: "text",
                                      readonly: _vm.check_if_locked(field),
                                      state: _vm.is_valid_field(field),
                                      id: field.type + field.id,
                                      size: "sm",
                                    },
                                    model: {
                                      value: field.insert_val,
                                      callback: function ($$v) {
                                        _vm.$set(field, "insert_val", $$v)
                                      },
                                      expression: "field.insert_val",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              field.type == "enum_vid_remont"
                                ? _c("b-form-radio-group", {
                                    attrs: {
                                      id: "btn-radios-1",
                                      "button-variant": "outline-primary",
                                      options: _vm.remont_options,
                                      name: "radios-btn-default",
                                      buttons: "",
                                    },
                                    model: {
                                      value: field.insert_val,
                                      callback: function ($$v) {
                                        _vm.$set(field, "insert_val", $$v)
                                      },
                                      expression: "field.insert_val",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              field.type == "date"
                                ? _c("date-picker", {
                                    attrs: {
                                      "value-type": "format",
                                      lang: _vm.d_lang,
                                      "first-day-of-week": 1,
                                    },
                                    model: {
                                      value: field.insert_val,
                                      callback: function ($$v) {
                                        _vm.$set(field, "insert_val", $$v)
                                      },
                                      expression: "field.insert_val",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              field.type == "api_place"
                                ? _c(
                                    "v-select",
                                    {
                                      staticClass: "imc_reasons",
                                      attrs: {
                                        label: "name",
                                        options: _vm.draw_places_fields,
                                        filterable: false,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "option",
                                            fn: function (option) {
                                              return [
                                                _c(
                                                  "div",
                                                  { staticClass: "d-center" },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(option.name) +
                                                        "\n                                            "
                                                    ),
                                                    _c("small", [
                                                      _vm._v(
                                                        _vm._s(option.edrpou)
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: _vm.place_field,
                                        callback: function ($$v) {
                                          _vm.place_field = $$v
                                        },
                                        expression: "place_field",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "no-options" }, [
                                        _vm._v(
                                          "\n                                        Оберіть склад\n                                    "
                                        ),
                                      ]),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "part_items" },
          [
            _c("parts_items", {
              attrs: { parts_field: _vm.get_filed("parts") },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }